mutation DeletePlatformMenuItems($ids: [ID!]!) {
  deletePlatformMenuItems(ids: $ids) {
    id
  }
}
